module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/marker-db.eb74c434..png" + "?" + Date.now();